'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

var _paths2 = require('../events/paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, adj_id, person_id, score_id, data) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      adj_id: adj_id,
      person_id: person_id,
      score_id: score_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.scoreByAdjudicatorUrl)(feis_id, event_id, adj_id, person_id) + '/' + score_id,
        method: 'PUT',
        data: data
      },
      types: ['UPDATE_SCORE_START', 'UPDATE_SCORE', 'UPDATE_SCORE_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/scores/updateScore.js
// module id = 675
// module chunks = 0